import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { getCurrentUserInfo } from '@services/Cookies';
import { syncApplicationLanguage } from '@utils/language';

const currentUser = getCurrentUserInfo();
const browserLanguage = navigator.language.slice(0, 2);
const initialLanguage = currentUser?.default_locale_code ?? (
  browserLanguage === 'ja' ? 'ja' : 'en'
);
syncApplicationLanguage(initialLanguage);

// 未処理エラーをRUMが拾えるようにする（明示送信はしない）
window.addEventListener('error', (event: ErrorEvent) => {
  console.error('Unhandled error', event.error ?? event.message);
});

window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
  console.error('Unhandled promise rejection', event.reason);
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

root.render(
  <App />
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
